module.exports = __webpack_public_path__ + "epilace_3_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/epilace_3_after.jpg
// module id = 947
// module chunks = 0